import type { Account, Broker } from '../types';

export function updateBrokerAccounts(
  brokers: Broker[],
  accountId: string,
  updater: (account: Account) => Account,
): Broker[] {
  return brokers.map((broker) => ({
    ...broker,
    accounts: broker.accounts.map((account) => (
      account.accountId === accountId ? updater(account) : account
    )),
  }));
}

export function removeHoldingAmount(account: Account, token: string, amount: number): Account {
  const holdings = account.holdings.map((holding) => {
    if (holding.token !== token) {
      return holding;
    }

    const nextHolding = Math.max(holding.frozen, holding.holding - amount);
    return {
      ...holding,
      holding: nextHolding,
    };
  });

  return {
    ...account,
    holdings,
    usdcBalance: token === 'USDC' ? Math.max(0, account.usdcBalance - amount) : account.usdcBalance,
  };
}
